module.exports = __webpack_public_path__ + "14_scitech.jpg?e32f3e0681fe1059098701542622844a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/14_scitech.jpg
// module id = 154
// module chunks = 0